import { UnknownAutomationObject } from './UnknownAutomationObject';

import { Apps as Plants } from './Plants/appDeclarations';
import { Apps as SubPlants } from './SubPlants/appDeclarations';
import { Apps as Functions } from './Functions/appDeclarations';
import { Apps as FunctionGroups } from './FunctionGroups/appDeclarations';
import { Apps as Utils } from './Utils/appDeclarations';
import { Apps as KPIs } from './KPIs/appDeclarations';
import { Apps as Misc } from './Misc/appDeclarations';
import { Apps as Devices } from './Devices/appDeclarations';
import { Apps as Collections } from './Collections/appDeclarations';
import { IAutomationAppComponent } from './types';
import { Apps as ReportsAndStatistics } from './ReportsAndStatistics/appDeclarations'
import { Apps as Logics } from './Logics/appDeclarations'

interface IDictionary {
    [index: string]: IAutomationAppComponent;
}

export const componentsRegistry: IDictionary = {
    ...Plants,
    ...SubPlants,
    ...Functions,
    ...FunctionGroups,
    ...Utils,
    ...Misc,
    ...Devices,
    ...Collections,
    ...ReportsAndStatistics,
    ...Logics,
    ...KPIs
} 


export function AutomationObjectsSelector(props) : any {

    const MyNewComponent = componentsRegistry[props.tag]?.OverviewPanel;
    if (MyNewComponent) return <MyNewComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

export function AutomationObjectsOperatorPanelSelector(props) : any {
    const MyNewComponent = componentsRegistry[props.tag]?.OperatorPanel;
    if (MyNewComponent) return <MyNewComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}
export function IsSmartApp(props): boolean {
    return componentsRegistry[props.tag]?.isSmartApp ?? false;
}
export function HasParameterPanel(props): boolean {
    return componentsRegistry[props.tag]?.ParameterPanel !== undefined ? true : false;
}
export function HasOperatorPanel(props): boolean {
    return componentsRegistry[props.tag]?.OperatorPanel !== undefined ? true : false;
}
export function AutomationObjectsParameterPanelSelector(props): any {
    const MyNewComponent = componentsRegistry[props.tag]?.ParameterPanel;
    if (MyNewComponent) return <MyNewComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

export function AutomationObjectsSystemPanelSelector(props): any {
    const MyComponent = componentsRegistry[props.tag]?.SystemPanel;
    if (MyComponent) return <MyComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}
export function HasSystemPanel({tag}): boolean  {
    return componentsRegistry[tag]?.SystemPanel !== undefined ? true : false;
}
export function HasProcessPanel({tag}): boolean  {
    return componentsRegistry[tag]?.supportsProcessPanel || false;
}
export function HasConfigurationPanel(modelId: string): boolean  {
    return componentsRegistry[modelId]?.ConfigurationPanel !== undefined ? true : false;
}

export function AutomationObjectsConfigPanelSelector(props): any {
    const MyComponent = componentsRegistry[props.tag]?.ConfigurationPanel;
    if (MyComponent) return <MyComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

export function HasListPanel(modelId: string): boolean  {
    return componentsRegistry[modelId]?.ListPanel !== undefined ? true : false;
}
export function AutomationObjectsListSelector(props): any {
    const MyComponent = componentsRegistry[props.tag]?.ListPanel;
    if (MyComponent) return <MyComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

export function GetAppIcon(modelId: string): any  {
    return componentsRegistry[modelId]?.Icon;
}

// ****************
// insights Panel
// ****************
export function HasInsightsPanel(modelId: string): boolean {
    return componentsRegistry[modelId]?.InsightsPanel !== undefined ? true : false;
}
export function InsightsPanelSelector(props: { modelId: string, state: any, additionalProps?: any}): any {
    const MyComponent = componentsRegistry[props.modelId]?.InsightsPanel;
    if (MyComponent) return <MyComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

// ****************
// sideview Panel
// ****************
export function HasSideviewPanel(modelId: string): boolean {
    return componentsRegistry[modelId]?.SideViewPanel !== undefined ? true : false;
}
export function SideviewPanelSelector(props: { modelId: string, state: any, additionalProps?: any}): any {
    const MyComponent = componentsRegistry[props.modelId]?.SideViewPanel;
    if (MyComponent) return <MyComponent {...props.state} {...props.additionalProps}/>

    return <UnknownAutomationObject  {...props.state} {...props.additionalProps}></UnknownAutomationObject>
}

// add object 
export function HasAddAppSupport(modelId: string): boolean {
    return componentsRegistry[modelId]?.addAppFilter !== undefined ? true : false;
}
export function GetAddAppFilter(modelId: string) {
    return componentsRegistry[modelId]?.addAppFilter;
}